import {
  DocumentData,
  DocumentReference,
  DocumentSnapshot,
  FirestoreDataConverter,
  QueryConstraint,
  QueryDocumentSnapshot,
  SnapshotOptions,
  Timestamp,
  collection,
  doc,
  documentId,
  getCountFromServer,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { useQuery } from "react-query";
import { newDB } from "../db";

export type FirestoreFilterValue =
  | string
  | number
  | boolean
  | DocumentReference
  | string[]
  | null
  | undefined;

export type FirestoreQueryState<T> = {
  collection: string;
  clientID?: string;
  filters?: {
    field: keyof T;
    value: FirestoreFilterValue;
  }[];
  sorting: {
    field: keyof T;
    order: "asc" | "desc";
  };
  limit: number;
  currentPage: number;
  searchKey?: {
    field: keyof T;
    value: string;
    caseSensitive?: boolean;
  };
  priorityOrder?: boolean;
  refetchInterval?: number;
};

export type MapperFn<T> = (
  docs: QueryDocumentSnapshot<T, DocumentData>[]
) => T[] | Promise<T[]>;

export function createDocRef(collection: string, id: string) {
  return doc(newDB, `${collection}/${id}`);
}

export function useFirestoreData<T>(
  props: FirestoreQueryState<T>,
  mapper?: MapperFn<T>
) {
  const { collection } = props;
  const queryResult = useQuery(
    [`firestore-data-${collection}`, props],
    () => getDataFromDB(props, mapper),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      refetchInterval: props.refetchInterval,
    }
  );
  // const toUncover = queryResult.data?.items;
  // toUncover?.map((item) => {
  //   // console.log(item, "item ikos");
  // });
  // const {data: queryData} = queryResult

  // const data = getFilteredData(props, queryData?.items)

  // return {
  //   ...queryResult,
  //   data: data
  // }
  return queryResult;
}

async function getDataFromDB<T>(
  state: FirestoreQueryState<T>,
  mapper?: MapperFn<T>
) {
  const {
    clientID,
    collection: collName,
    sorting,
    limit: max,
    filters,
    currentPage,
    searchKey,
    priorityOrder,
  } = state;

  if (!clientID) {
    return { allCount: 0, items: [] };
  }

  const converterData: FirestoreDataConverter<T> = {
    toFirestore: (data) => data || {},
    fromFirestore: (snapshot: DocumentSnapshot, options: SnapshotOptions) => {
      const data = snapshot.data(options);
      return data as T;
    },
  };

  const countConstrains: QueryConstraint[] = [
    where("client", "==", createDocRef("clients", clientID)),
  ];

  if (filters) {
    const idFilter = filters.find((filter) => filter.field === "id");
    if (!!idFilter) {
      countConstrains.push(where(documentId(), "==", idFilter.value));
    } else {
      filters.forEach((filter) => {
        if (Array.isArray(filter.value)) {
          countConstrains.push(
            where(filter.field.toString(), "in", filter.value)
          );
          return;
        } else {
          countConstrains.push(
            where(filter.field.toString(), "==", filter.value)
          );
          return;
        }
      });
    }
  }

  if (searchKey && searchKey.value.length > 2) {
    if (searchKey.field === "id") {
      countConstrains.push(orderBy(documentId()));
    } else {
      countConstrains.push(orderBy(searchKey.field.toString(), "asc"));
    }
  }

  if (priorityOrder) {
    countConstrains.push(orderBy("orderPriorityNumber", "desc"));
  }

  if (searchKey?.field !== "id" || searchKey?.value?.length < 2) {
    countConstrains.push(orderBy(sorting.field.toString(), sorting.order));
  }

  if (searchKey && searchKey.value.length > 2) {
    if (searchKey?.field !== "id") {
      if (!!searchKey.caseSensitive) {
        countConstrains.push(
          where(searchKey.field.toString(), ">=", searchKey.value),
          where(searchKey.field.toString(), "<=", searchKey.value + "\uf8ff")
        );
      } else {
        countConstrains.push(
          where(
            searchKey.field.toString(),
            ">=",
            searchKey.value.toUpperCase()
          ),
          where(
            searchKey.field.toString(),
            "<=",
            searchKey.value.toLowerCase() + "\uf8ff"
          )
        );
      }
    } else {
      countConstrains.push(
        where(documentId(), ">=", searchKey.value.toUpperCase()),
        where(documentId(), "<=", searchKey.value.toLowerCase() + "\uf8ff")
      );
    }
  }

  try {
    const counterQuery = query(collection(newDB, collName), ...countConstrains);

    const dataConstrains = [...countConstrains];

    if (currentPage > 1) {
      const tempConstrain = [...countConstrains];

      tempConstrain.push(limit((currentPage - 1) * max));

      const tempDocs = (
        await getDocs(query(collection(newDB, collName), ...tempConstrain))
      ).docs;

      dataConstrains.push(startAfter(tempDocs[tempDocs.length - 1]));
    }

    dataConstrains.push(limit(max));

    console.log(dataConstrains, "checkcontrainsg tvu");

    const dataQuery = query(
      collection(newDB, collName).withConverter(converterData),
      ...dataConstrains
    );

    const count = (await getCountFromServer(counterQuery)).data().count;
    // const data = await getDataFromFirestore<T>(state, mapper)
    const docs = (await getDocs(dataQuery)).docs;
    console.log(docs, "test 1 daqu");

    console.log(dataQuery, "daqu");

    let data: T[] = [];
    if (mapper) {
      const tempData = await mapper(docs);
      data = [...tempData];
    } else {
      const tempData = docs.map((doc) => {
        return {
          id: doc.id,
          ...doc.data(),
        } as T;
      });
      data = [...tempData];
    }

    return { allCount: count, items: data };
  } catch (error) {
    console.log(`Error get firestore data table ${collName}`, error);
    return { allCount: 0, items: [] };
  }
}

export default useFirestoreData;
